/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Ms_Set_TargetInputs */

const en_ms_set_target = /** @type {(inputs: Ms_Set_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Target date of ${i?.name}`)
};

const de_ms_set_target = /** @type {(inputs: Ms_Set_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zieldatum von ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Target date of {name}" |
*
* @param {Ms_Set_TargetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ms_set_target = /** @type {((inputs: Ms_Set_TargetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ms_Set_TargetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ms_set_target(inputs)
	return en_ms_set_target(inputs)
});